import { Box, Grid, Typography } from '@mui/material';

import { InfoBox } from 'src/sections/employer-data/shared/components/info-box';

import { formatDollarAmount } from '../../../../../shared/utils/policyUtils';

import type { USRExposuresTotals } from '../types';

export function UnitStatExposuresTotals({ data }: { data: USRExposuresTotals }) {
  const totals = [
    { label: 'Subject premium', value: formatDollarAmount(data.subjectPremiumTotal) },
    { label: 'Standard exposure', value: formatDollarAmount(data.standardExposureTotal) },
    { label: 'Standard premium', value: formatDollarAmount(data.standardPremiumTotal) },
    { label: 'Modified premium', value: formatDollarAmount(data.modifiedPremiumTotal) },
  ];

  return (
    <Box>
      <Typography variant="subtitle1" data-testid="usr-exposures-totals-title" sx={{ mb: 2 }}>
        Exposure totals
      </Typography>
      <Grid container spacing={2} columns={4}>
        {totals.map((item) => (
          <Grid key={item.label} size={{ xs: 4, md: 1 }}>
            <InfoBox
              label={item.label}
              value={item?.value || ''}
              testIdLabel={item.label}
              testIdValue={item.label + '-value'}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
